import type { Era } from "@/types";

export const PROJECT_ERAS: Record<
  Era,
  { label: string; when: string; motto: string; dark: boolean }
> = {
  pre: {
    label: "Pre-GPT",
    when: "before 30 Nov 2022",
    motto: "Hand-written code, Stack Overflow tabs and a lot of patience.",
    dark: false,
  },
  post: {
    label: "Post-GPT",
    when: "after 30 Nov 2022",
    motto: "Built with LLMs, and increasingly for them.",
    dark: true,
  },
};
